import axios from "axios";
import { serviceBaseUrl } from "./constants";

export const getAllTeams = async (seasonId: string) => {
  try {
    const response = await axios.get(`${serviceBaseUrl}/teams/${seasonId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching teams:", error);
    throw error;
  }
};

export const createInvitationToTeam = async (
  seasonId: string,
  teamId: string,
  id: string,
  role: string
) => {
  try {
    const response = await axios.post(
      `${serviceBaseUrl}/createInvite`,
      {
        seasonId,
        teamId,
        id,
        role,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error sending invite:", error);
    throw error;
  }
};

export const getOwnerInvitees = async (seasonId: string, teamId: string) => {
  try {
    const response = await axios.post(`${serviceBaseUrl}/getInviteUsers`, {
      seasonId,
      teamId,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching owner invitees:", error);
    throw error;
  }
};

export const acceptInvite = async (seasonId: string, teamId: string) => {
  try {
    const response = await axios.post(`${serviceBaseUrl}/acceptInvite`, {
      seasonId,
      teamId,
    });
    return response.data;
  } catch (error) {
    console.error("Error accepting invite:", error);
    throw error;
  }
};

export const rejectInvite = async (seasonId: string, teamId: string) => {
  try {
    const response = await axios.post(`${serviceBaseUrl}/rejectInvite`, {
      seasonId,
      teamId,
    });
    return response.data;
  } catch (error) {
    console.error("Error rejecting invite:", error);
    throw error;
  }
};

export const getPlayerInvitees = async (seasonId: string, teamId: string) => {
  try {
    const response = await axios.post(`${serviceBaseUrl}/getInvitePlayers`, {
      seasonId,
      teamId,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching player invitees:", error);
    throw error;
  }
};

export const getTeamDetails = async (teamId: string) => {
  try {
    const response = await axios.get(
      `${serviceBaseUrl}/getTeamDetails/${teamId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching team details:", error);
    throw error;
  }
};

export const declineInviteByTeamOwner = async (
  teamId: string,
  inviteId: string
) => {
  try {
    const response = await axios.post(
      `${serviceBaseUrl}/declineInviteByTeamOwner`,
      {
        inviteId,
        teamId,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error declining invite:", error);
    throw error;
  }
};

export const setAsCaptain = async (teamId: string, playerId: string) => {
  try {
    const response = await axios.post(`${serviceBaseUrl}/assignTeamCaptain`, {
      teamId,
      playerId,
    });
    return response.data;
  } catch (error) {
    console.error("Error setting as captain:", error);
    throw error;
  }
}

export const shortlistPlayers = async (teamId: string, shortlistedPlayers: any[]) => {
  try {
    const response = await axios.post(`${serviceBaseUrl}/teams/${teamId}/shortlistPlayers`, {
      shortlistedPlayers,
    });
    return response.data;
  } catch (error) {
    console.error("Error shortlisting players:", error);
    throw error;
  }
}


export const getTeamPlayerDetailsForSelection = async (teamId: string, matchId: string) => {
  try {
    const response = await axios.get(`${serviceBaseUrl}/getTeamDetailsForSelection/${teamId}/${matchId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching team player details:", error);
    throw error;
  }
}